module.exports = __webpack_public_path__ + "img/magdalena_1.a7b71493.png";